import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.readHistory.loading;
export const selectErrorMessage = (state: RootState) => state.readHistory.error;
export const readHistoryListDataResponse = (state: RootState) =>
  state.readHistory.readHistoryListResponse;
